import React from "react";
import { Box, Button, Container, Typography } from "@mui/material";
import { palette } from "./palette";

const TopAlert = ({ onClick }) => (
  <Box
    sx={{
      width: "100%",
      backgroundColor: palette.text,
      color: palette.bg,
      py: 1.25,
    }}
  >
    <Container maxWidth="lg">
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          textAlign: "center",
        }}
      >
        <Typography
          component="p"
          sx={{
            fontFamily: "Be Vietnam Pro",
            fontSize: { xs: 13, sm: 14 },
            color: palette.bg,
          }}
        >
          Intake is open · 50 places, then we close until the next one
        </Typography>
        <Button
          onClick={onClick}
          disableElevation
          sx={{
            px: 2,
            py: 0.4,
            borderRadius: "999px",
            backgroundColor: palette.primary,
            color: "#ffffff",
            fontFamily: "Be Vietnam Pro",
            fontSize: 12.5,
            fontWeight: 600,
            textTransform: "none",
            whiteSpace: "nowrap",
            "&:hover": { backgroundColor: palette.primaryHover },
          }}
        >
          Talk to us
        </Button>
      </Box>
    </Container>
  </Box>
);

export default TopAlert;
